import React, { useState, useContext, useEffect } from "react";

import {
  InputCopy,
  FormGroup,
  Dropdown,
  FormFooter,
  Select,
  Tooltip,
  StatusDot,
  ContentBlock,
  Breadcrumbs,
  Checkbox,
  Subheader,
  Pill,
  Collapse,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";
import { PAinfoCollapsible } from "./../PAconnectors";

import {
  PAgkRefundPeriods,
  PAgkRefundOption,
  SelectSquare,
  PAgkRefundLine,
  CssTableFlag,
  CssTableCountry
} from "../ffr/PAgkRefund";

import merge from "deepmerge";

import DatePickerExample from "./../DatePicker";
import SelectExample from "./../SelectExample";
import { timezones, years } from "./PAgameKeys";





export function PAgcGKbuypre({ data }) {
  const [buyPre, setBuyPre] = useState(false);
  const [state, setState] = useState({ data: data });

  // const handlePreOrders = (newValue = "buy") => {
  //   let newData = {
  //     keyData: {
  //       buyPre: {
  //         ...buyPre,
  //         value: newValue
  //       }
  //     }
  //   };
  //   setState(
  //     {
  //       data: {
  //         ...merge({ ...data }, newData)
  //       }
  //     },
  //     () => {
  //       // this.updateStatus();
  //     }
  //   );
  // };


  const [pre, setPre] = useState(false)

  const [preWhen, setPreWhen] = useState('exact')


  return (
    <FormGroup label="Purchase type" indentation="lg">
      {/* <FormGroup label="" indentation="md">
        <RadioGroup
          direction="row"
          input={{
            value: data.keyData.buyPre
              .value,
            onChange: e => {
              setState(
                {
                  data: merge(data, {
                    keyData: {
                      buyPre: {
                        value: e.target.value
                      }
                    }
                  })
                },
                () => {
                  // updateStatus();
                }
              );
            }
          }}
          options={[
            {
              radioValue: "buy",
              label: "Buy now"
            },
            {
              radioValue: "pre",
              label: "Pre-order"
              // tooltip: "Tooltip message"
            }
          ]}
        />
      </FormGroup> */}

      <FormGroup label="" indentation="md">
        <div
          className="xsui-radio_group__wrapper xsui-radio_group__wrapper--direction-row"
          // style={{ height: 90 }}
        >
          <label
            className={
              !pre
                ? "xsui-radio_group__items--background xsui-radio_group__items--background-selected"
                : "xsui-radio_group__items--background"
            }
            style={{
              // height: 90,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            onClick={e => {
              setPre(false)
              // handlePreOrders("buy");
            }}
          >
            <div className="xsui-radio">Buy Now</div>
          </label>
          <label
            className={
              pre
                ? "xsui-radio_group__items--background xsui-radio_group__items--background-selected"
                : "xsui-radio_group__items--background"
            }
            style={{
              // height: 90,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            onClick={e => {
              setPre(true)
              // handlePreOrders("pre");
            }}
          >
            <div className="xsui-radio">Pre-order</div>
          </label>
        </div>
      </FormGroup>

      {pre && (
        <FormGroup label="Release date" indentation="xs" >
          <FormGroup label="" indentation="md">
            <RadioGroup
              direction="row"
              input={{
                value: preWhen,
                onChange: e => {setPreWhen(e.target.value)}
              }}
              options={[
                {
                  radioValue: "exact",
                  label: "Exact date"
                },
                {
                  radioValue: "quarter",
                  label: "Quarter"
                  // tooltip: "Tooltip message"
                }
              ]}
            />
          </FormGroup>

          {preWhen === "exact" && (
            <FormGroup label="" indentation="md">
              <div className="preorder-block__release-date">
                <DatePickerExample
                  canBeEmpty={false} //TODO: важно, не должно быть пустого
                  date={new Date()}
                />
              </div>
              <div className="preorder-block__utc-offset">
                <SelectExample size="sm" options={timezones} />
              </div>
            </FormGroup>
          )}

          {preWhen === "quarter" && (
            <FormGroup label="" indentation="lg">
              <div className="preorder-block__release-date">
                <SelectExample
                  size="sm"
                  // title="Release year"
                  canBeEmpty={false} //TODO: важно, не должно быть пустого
                  options={years}
                />
              </div>
              <div className="preorder-block__release-date">
                <SelectExample
                  size="sm"
                  // title="Release quarter"
                  options={[
                    {
                      label: "Q1 (January–March)",
                      value: "1"
                    },
                    {
                      label: "Q2 (April–June)",
                      value: "2"
                    },
                    {
                      label: "Q3 (July–September)",
                      value: "3"
                    },
                    {
                      label: "Q4 (October–December)",
                      value: "4"
                    }
                  ]}
                />
              </div>
            </FormGroup>
          )}
        </FormGroup>
      )}





    </FormGroup>
  );
}
